export default "__VITE_ASSET__Dch_g2lP__"